module.exports = "data:image/gif;base64,R0lGODdhAQABAIABAPT09P///ywAAAAAAQABAAACAkQBADs="